/* eslint-disable @typescript-eslint/ban-ts-comment */
import { v4 } from 'uuid';
import { BeneficialOwnerFormData } from '../components/controlPersonInformationStep';
import ClientApi from '@src/types/client';
import { format } from 'date-fns';
import { checkNAValues } from '@src/utils/checkNAValues';

export const getControlPersonInfoInitialValues = (
  businessInformationDetails:
    | ClientApi.Onboarding.GetBusinessInformationDetails.Response['data']
    | null
) => {
  if (!businessInformationDetails?.controlPerson) {
    const userId = v4();
    return {
      peopleId: [userId],
      people: [],
      [`shareSize-${userId}`]: '',
      [`legalFirstName-${userId}`]: '',
      [`legalLastName-${userId}`]: '',
      [`dateOfBirth-${userId}`]: '',
      [`email-${userId}`]: '',
      [`formId-${userId}`]: '',
      [`agencyApplicationForm-${userId}`]: null,
      [`driverLicense-${userId}`]: null,
      [`occupation-${userId}`]: '',
      [`socialSecurityNumber-${userId}`]: ''
    };
  }

  const initialValues = {
    peopleId: businessInformationDetails?.controlPerson.map((_, index) => String(index)),
    people: []
  } as BeneficialOwnerFormData;

  businessInformationDetails?.controlPerson.forEach((owner, index) => {
    // @ts-ignore
    initialValues[`legalFirstName-${index}`] = checkNAValues(owner.firstName || '');
    // @ts-ignore
    initialValues[`legalLastName-${index}`] = checkNAValues(owner.lastName || '');
    // @ts-ignore
    initialValues[`dateOfBirth-${index}`] = checkNAValues(formatDate(owner.dateOfBirth) || '');
    // @ts-ignore
    initialValues[`email-${index}`] = checkNAValues(owner.email || '');
    // @ts-ignore
    initialValues[`homePhoneNumber-${index}`] = checkNAValues(owner.homePhoneNumber || '');
    // @ts-ignore
    initialValues[`address-${index}`] = checkNAValues(owner.homeAddress || '');
    // @ts-ignore
    initialValues[`country-${index}`] = checkNAValues(owner.countryOfResidence || '');
    // @ts-ignore
    initialValues[`stateOfResidence-${index}`] = checkNAValues(owner.stateOfResidence || '');
    // @ts-ignore
    initialValues[`city-${index}`] = checkNAValues(owner.city || '');
    // @ts-ignore
    initialValues[`zipCode-${index}`] = checkNAValues(owner.zipCode || '');
    // @ts-ignore
    initialValues[`idNumber-${index}`] = checkNAValues(owner?.uboBusinessDocuments?.idNumber || '');
    // @ts-ignore
    initialValues[`formId-${index}`] = checkNAValues(owner?.uboBusinessDocuments?.idType || '');
    // @ts-ignore
    initialValues[`agencyApplicationForm-${index}`] = checkNAValues(
      owner?.uboBusinessDocuments?.uboIdentificationDocument || null
    );
    // @ts-ignore
    initialValues[`driverLicense-${index}`] = checkNAValues(
      owner?.uboBusinessDocuments?.uboIdentificationDocumentBackSide || null
    );
    // @ts-ignore
    initialValues[`shareSize-${index}`] = checkNAValues(owner.shareSize || '');
    // @ts-ignore
    initialValues[`socialSecurityNumber-${index}`] = checkNAValues(
      owner.socialSecurityNumber || ''
    );
    // @ts-ignore
    initialValues[`occupation-${index}`] = checkNAValues(owner.occupation || '');
    // @ts-ignore
    initialValues[`id-${index}`] = checkNAValues(owner?.id || '');
  });

  return initialValues;
};

const formatDate = (date: string | undefined) => {
  if (!date) return '';
  try {
    return format(date, 'yyyy-MM-dd');
  } catch (error) {
    return '';
  }
};
